<main class="gratuity_confirm">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{ _(app.gratuity.texts.title) }}</h1>
            <span
                class="icon back"
                @click="app.updateQuery({ 
                page: 'GratuityDetail', 
                staff_id: app.query.staff_id, 
            })"
                >chevron_left</span
            >
        </div>
    </header>
    <div id="background"></div>
    <img class="staff_image" :src="gratuityStaff.image_urls[0]" />
    <div class="descriptions">
        <h2 class="title">{{ _(gratuityStaff.texts.staff_name) }}</h2>
        <p style="white-space: pre-line">
            {{ _(gratuityStaff.texts.staff_description) }}
        </p>
    </div>

    <template v-if="app.reserves_rooms.length > 1" class="wrap-input select">
        <hr />
        <div class="pulldown_column">
            <h3 class="talign_right">{{_('per_room')}}</h3>
            <div>
                <div v-if="!!selectRoom">
                    <template
                        >{{_('room_count', selectRoom.index)}}
                        ({{_(selectRoom.name)}})</template
                    >
                </div>
            </div>
        </div>
    </template>

    <template>
        <hr />
        <div class="pulldown_column">
            <h3>{{ _('gratuity_price') }}</h3>
            <div>{{amount | price }}</div>
        </div>
    </template>

    <template v-if="comment.length > 0">
        <hr />
        <div class="pulldown_column">
            <h3>{{_(app.gratuity.texts.message_description)}}</h3>
            <div>{{comment}}</div>
        </div>
    </template>

    <template v-if="app.gratuity.texts.notice[app.getLang()].length > 0">
        <hr />
        <div class="pulldown_column">
            <section class="remarks">
                <pre>{{ _(app.gratuity.texts.notice) }}</pre>
            </section>
        </div>
    </template>

    <div id="cart-bar">
        <div class="cart-bar-content single-content">
            <button :disabled="isProcessing" @click="makePayment()">
                {{_('give_gratuity')}}
            </button>
        </div>
    </div>
</main>
